import { useQuery } from '@tanstack/react-query';

import { signatureApi } from '../axios';

export function useUserFormSignatureInfoQuery(
  formAnswerId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['userFormSignatureInfo', formAnswerId],
    queryFn: () => signatureApi.getUserFormSignInfo(formAnswerId),
    enabled: !!formAnswerId && (options?.enabled ?? true),
  });
}

export function useUserSignatureStateQuery() {
  return useQuery({
    queryKey: ['userSignatureState'],
    queryFn: () => signatureApi.getUserSignatureState(),
  });
}

export function useCompletedSignaturesQuery(
  formAnswerId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['completedSignatures', formAnswerId],
    queryFn: () => signatureApi.getFormAnswerCompletedSignatures(formAnswerId),
    // This endpoint is authenticated; skip it on public/token views (401).
    enabled: !!formAnswerId && (options?.enabled ?? true),
  });
}

export function usePendingSignaturesCountQuery() {
  return useQuery({
    queryKey: ['pendingSignaturesCount'],
    queryFn: () => signatureApi.getPendingSignaturesCount(),
    select: (data) => data.pending_signatures,
  });
}

export function useExternalUserFormSignatureInfoQuery(token: string) {
  return useQuery({
    queryKey: ['externalUserFormSignatureInfo', token],
    queryFn: () => signatureApi.getExternalUserFormSignInfo(token),
    enabled: !!token,
  });
}

export function useImplementationRequestDateQuery() {
  return useQuery({
    queryKey: ['implementationRequestDate'],
    queryFn: () => signatureApi.getImplementationRequestDate(),
  });
}
